import * as t from "io-ts";

export const geolocationCodec = t.partial({
  streetAddress: t.string,
  city: t.string,
  state: t.string,
  country: t.string,
  postalCode: t.string,
});

/**
 * A custom codec for a location.
 */
export const locationCodec = t.intersection([
  t.type({
    address: t.string,
    lat: t.number,
    lng: t.number,
  }),
  t.partial({ geolocation: geolocationCodec }),
]);

export interface Geolocation {
  streetAddress?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}

/**
 * Refers to a location.
 */
export interface Location {
  /**
   * Human-readable address.
   */
  address: string;

  /**
   * Lat/lng coordinates.
   */
  lat: number;
  lng: number;
  distance?: number;
  /**
   * Bounding box coordinates.
   */
  bbNeLat?: number;
  bbNeLng?: number;
  bbSwLat?: number;
  bbSwLng?: number;
  /**
   * Geo components of the address
   */
  geolocation?: Geolocation;
}
